import * as yup from "yup";

export const questionFormSchema = yup.object({
  risk_profile: yup.string().required("Risk Profile is required"),
  life_stage: yup.string().required("Life Stage is required"),
  financial_and_familyGoal: yup
    .string()
    .required("Financial and Family Goal is required"),
});
